import { ActionFunction, ActionFunctionArgs, LoaderFunctionArgs } from 'react-router-dom';
import { UserStateData } from './types';

export type Tier = 'basic' | 'essentials';

export enum PermissionType {
  Workspace = 'workspace',
  Organization = 'organization',
  Both = 'both',
}

export type LoaderUserData = Omit<UserStateData, 'userId'> & { userId: string };

export interface AuthActionFunction {
  (args: ActionFunctionArgs, user: LoaderUserData): ReturnType<ActionFunction>;
}

export interface AuthLoaderFunction<ReturnType extends object = object> {
  (
    args: LoaderFunctionArgs,
    user: Omit<UserStateData, 'userId'> & { userId: string },
  ): Promise<ReturnType extends Response | infer T ? T : null>;
}

export interface AuthLoaderArgs {
  args: LoaderFunctionArgs;
  user: Omit<UserStateData, 'userId'> & { userId: string };
}
